import '../../styles/sections/header/mobile-nav.scss';

class MobileNav extends HTMLElement {
  constructor() {
    super();

    this.wrapper = document.querySelector('[data-mobile-nav-wrapper]');

    this.currentActiveMenu = undefined;
    
    // Track navigation path for breadcrumb display
    this.navigationPath = [];

    // Open submenus
    this.openSubmenuButtons = this.querySelectorAll('[data-open-submenu]');

    this.openSubmenuButtons.forEach(button => {
      button.addEventListener('click', this.openSubmenu.bind(this));
    });

    // Previous button
    this.previousButton = this.wrapper.querySelector('[data-mobile-nav-previous]');
    this.previousSubmenuTitleElement = this.wrapper.querySelector('[data-previous-submenu-title]');
    this.previousButton.addEventListener('click', this.goToPreviousNav.bind(this));

    // Close buttons
    this.closeDelay = this.wrapper.querySelector('details-disclosure').getAttribute('close-delay');
    this.closeButtons = this.wrapper.querySelectorAll('close-details');

    this.closeButtons.forEach(button => {
      button.addEventListener('click', this.closeMobileNav.bind(this));
    });
  }

  openSubmenu(e) {
    const parent = e.target.closest('[data-submenu-parent]');
    const submenuTitle = parent.querySelector('[data-submenu-title]').dataset.submenuTitle;

    // Add current title to navigation path
    this.navigationPath.push(submenuTitle);
    this.updateBreadcrumb();

    const previousNav = parent.closest('[data-submenu]');
    const targetNav = parent.querySelector('[data-submenu]');

    targetNav.style.setProperty("--scroll-distance", `${previousNav.scrollTop}px`);
    targetNav.classList.add('active');
    previousNav.classList.add('disable-scroll');

    this.currentActiveMenu = targetNav;

    this.activatePreviousButton();
  }

  goToPreviousNav() {
    this.currentActiveMenu.classList.remove('active');

    this.currentActiveMenu = this.currentActiveMenu.parentNode.closest('[data-submenu]');

    this.currentActiveMenu.classList.remove('disable-scroll');

    // Remove last item from navigation path
    this.navigationPath.pop();
    this.updateBreadcrumb();

    if (this.currentActiveMenu.hasAttribute("data-submenu-root")) {
      this.deactivatePreviousButton();
    }
  }

  activatePreviousButton() {
    this.previousButton.classList.add('active');


  }

  deactivatePreviousButton() {
    this.previousButton.classList.remove('active');
  }

  closeMobileNav() {
    const activeSubmenus = this.wrapper.querySelectorAll('[data-submenu]');

    window.setTimeout(() => {
      activeSubmenus.forEach(submenu => {
        submenu.classList.remove('disable-scroll');
        submenu.classList.remove('active');
        this.deactivatePreviousButton();
      });

      // Reset navigation path when closing
      this.navigationPath = [];
      this.updateBreadcrumb();

    }, this.closeDelay);
  }

  updateBreadcrumb() {
    if (!this.previousSubmenuTitleElement) return;

    // Clear existing content
    this.previousSubmenuTitleElement.innerHTML = '';

    if (this.navigationPath.length > 0) {
      // Create separate span elements for each title
      this.navigationPath.forEach((title, index) => {
        const titleElement = document.createElement('span');
        titleElement.className = 'mobile-nav__breadcrumb-item';
        titleElement.textContent = title;
        this.previousSubmenuTitleElement.appendChild(titleElement);
      });
    }
  }
}

customElements.define('mobile-nav', MobileNav);
